import React from 'react';
import Header from '../Header';

function NoMatch() {
  return (
  	<main>
	    <Header pageName="404 Error" hasBackButton={true}/>
		<div className="container py-3 text-center">
			<h2 className="h3">Page does not exist</h2>
			<p>¯\_(ツ)_/¯</p>
		</div>			
	</main>			
  );
}

export default NoMatch;